import { registerRoot } from 'remotion'
import { mountAgentation } from './agentation'
import { RemotionStudio } from './RemotionStudio'

registerRoot(RemotionStudio)
mountAgentation()
